import { useAbility } from '@casl/react'
import { useNavigate, Location, matchPath } from 'react-router-dom'
import { AbilityContext } from '~/casl_context'

import {
  locationHistoryVar,
  authTokenVar,
  addLocationToHistory,
  getItemFromSS,
  AUTH_TOKEN_LS_KEY,
  AUTH_REFRESH_TOKEN_LS_KEY,
  getItemFromLS,
} from '~/core/apolloClient'
import { CustomRouteObject, LOGIN_ROUTE, HOME_ROUTE, ERROR_404_ROUTE } from '~/core/router'
import _ from 'lodash'

type GoBack = (
  fallback: string,
  options?: {
    // Previous count represents how many location from now you want to go back to
    previousCount?: number
    exclude?: string | string[]
  }
) => void

type UseLocationHistoryReturn = () => {
  onRouteEnter: (routeConfig: CustomRouteObject, location: Location) => void
  goBack: GoBack
}

const getPreviousLocation = ({
  previousCount = -1,
  exclude,
}: {
  previousCount?: number
  exclude?: string | string[]
}) => {
  const previousLocations = locationHistoryVar()
  const index = exclude
    ? previousLocations.findIndex((location, i) => {
        if (i < Math.abs(previousCount)) {
          return false
        }

        // If exclude, find index of the first location that doesn't match
        const isExluded =
          typeof exclude === 'string'
            ? matchPath(exclude, location.pathname)
            : exclude.some((pathToExclude) => matchPath(pathToExclude, location.pathname))

        return !isExluded
      })
    : Math.abs(previousCount)

  return {
    previous: previousLocations[index],
    remaingHistory: index > -1 ? previousLocations.slice(index + 1) : [],
  }
}

export const useLocationHistory: UseLocationHistoryReturn = () => {
  const navigate = useNavigate()
  const ability = useAbility(AbilityContext)
  const goBack: GoBack = (fallback, options) => {
    const { previous, remaingHistory } = getPreviousLocation(options || {})

    navigate(previous || fallback)

    locationHistoryVar(remaingHistory || [])
  }

  return {
    onRouteEnter: (routeConfig, location) => {
      let token = getItemFromLS(AUTH_REFRESH_TOKEN_LS_KEY) || getItemFromSS(AUTH_TOKEN_LS_KEY)

      const isAuthenticated = !!token
      if (routeConfig.onlyPublic && isAuthenticated) {
        /**
         * In case of navigation to a only public route while authenticated
         * Go back to previously visited page in app or fallback to the home
         */
        goBack(HOME_ROUTE, { previousCount: 0 })
      } else if (routeConfig.private && !isAuthenticated) {
        /**
         * In case of navigation to a private route while NOT authenticated
         * Redirect to login and add the route the user tried to visit in the history
         */
        navigate(LOGIN_ROUTE)
        addLocationToHistory(location)
      } else if (!routeConfig.children && !routeConfig.onlyPublic) {
        /**
         * We add the current location to the history only if :
         * - Current route has no children (to avoid adding Layout route which will result in duplicates)
         * - Current route is not an only public route
         */
        addLocationToHistory(location)

        // if (!routeConfig?.guards) {
        //   addLocationToHistory(location)
        // }
        // var canGuards = routeConfig?.guards?.map(item => ability.can(item[0],item[1]))

        // if(_.some(canGuards) || routeConfig.path == ERROR_404_ROUTE) {
        //   addLocationToHistory(location)
        // }
        // else
        // {
        //   navigate(ERROR_404_ROUTE)
        // }
      }
    },
    goBack,
  }
}
